import React from 'react';
import {Stack, Typography} from '@mui/material';

const LegalSection = props=>{
    let {title, children} = props;
    return <Stack direction="column" gap={1}>
      {title&&<Typography variant="h5">{title}</Typography>}
      {children}
    </Stack>;
};

export default LegalSection;
